module.exports = {
  1: 20856519,
  56: 42678795,
  137: 62421566,
  8453: 20414686,
  42161: 258599054,
  43114: 51146988,
  59144: 10096855,
  11155111: 7203627,
}
